import React from "react";

export default function ServicePrice({ service }) {
  const original = service.catalog_original_price ?? service.original_price ?? service.price;
  const price = service.price ?? service.discounted_price ?? original;
  const discounted = original > price && price >= 0;
  // Round down so the displayed saving never overstates the actual discount.
  const percentage = discounted ? Math.floor(((original - price) / original) * 100) : 0;
  return (
    <span className="inline-flex flex-wrap items-baseline gap-x-2 gap-y-1 tabular-nums">
      <span className="font-bold">₹{price}</span>
      {discounted && <del className="text-sm font-normal text-slate-500"><span className="sr-only">Original price </span>₹{original}</del>}
      {discounted && <span className="inline-flex rounded-full bg-emerald-50 px-2 py-0.5 text-[10px] font-bold leading-5 tracking-wide text-emerald-700">{percentage > 0 ? `${percentage}% OFF` : "<1% OFF"}</span>}
    </span>
  );
}
